import clsx from 'clsx';

interface Props {
  className?: string;
  colorMode?: 'auto' | 'dark' | 'light';
  orientation?: 'vertical' | 'horizontal';
}

export const Divider = ({
  className,
  colorMode = 'auto',
  orientation = 'horizontal',
}: Props) => {
  const classes = useStyles();

  return (
    <hr
      className={clsx(
        className,
        classes.orientation[orientation],
        classes.colorMode[orientation][colorMode]
      )}
    />
  );
};

const useStyles = () => ({
  orientation: {
    vertical: 'h-auto h-full w-[1px] border-0 self-stretch',
    horizontal: 'w-full ',
  },
  colorMode: {
    vertical: {
      auto: 'bg-border-light dark:bg-white/10',
      dark: 'bg-white/10',
      light: 'bg-border-light',
    },
    horizontal: {
      auto: 'border-t-border-light dark:border-t-border-dark',
      dark: 'border-t-border-dark',
      light: 'border-t-border-light ',
    },
  },
});
